import firebase from 'firebase/compat/app';
import { shortNoteCreator } from "../AddNote";
import { auth, firestore } from "./firebase";

export const dbOldNotes = firestore.collection("/notes");
const db = firestore.collection("/data");
const getAllShorts = () => db.doc(auth.currentUser.uid).get();

const updateShort = async (note) => {
  let userData = await getAllShorts().then((docRef) => docRef.data());
  let newNotes;
  if (userData && userData.shorts) {
    const foundNote = userData.shorts.find((n) => n.id === note.id);

    if (foundNote) {
      newNotes = userData.shorts.map((n) => (n.id === foundNote.id ? note : n));
    } else {
      newNotes = [...userData.shorts, note];
    }
    return updateShorts(newNotes);
  } else {
    return db.doc(auth.currentUser.uid).set({ shorts: [note] });
  }
};

const removeShortById = async (id) => {
  let oldNotes = await getAllShorts().then((docRef) => docRef.data());
  return updateShorts(oldNotes.shorts.filter((note) => note.id !== id));
};

const updateShorts = (notes) => {
  return db.doc(auth.currentUser.uid).update({ shorts: notes });
};

const getByID = (id) =>
  db.doc(auth.currentUser.uid).collection("notes").doc(id).get();

const create = (data) =>
  db
    .doc(auth.currentUser.uid)
    .collection("notes")
    .add({
      ...data,
      createdAt:
        data.createdAt ?? firebase.firestore.FieldValue.serverTimestamp(),
    });

const update = (id, data) =>
  db
    .doc(auth.currentUser.uid)
    .collection("notes")
    .doc(id)
    .set({
      ...data,
      modifiedAt: firebase.firestore.FieldValue.serverTimestamp(),
    });

const remove = (id) =>
  db.doc(auth.currentUser.uid).collection("notes").doc(id).delete();

const migrate = async () => {
  const shortsArr = [];

  const oldNotes = await dbOldNotes
    .where("userId", "==", auth.currentUser.uid)
    .get();

  for (const oldNote of oldNotes.docs) {
    const data = oldNote.data();
    const newNote = await NotesService.create(data);
    shortsArr.push(
      shortNoteCreator(
        data,
        data.createdAt.seconds * 1000,
        data.modifiedAt ? data.modifiedAt.seconds * 1000 : null,
        newNote.id
      )
    );
  }

  await db.doc(auth.currentUser.uid).set({ shorts: [...shortsArr] });
  console.log("finished");
};

const NotesService = {
  getAllShorts,
  updateShort,
  removeShortById,
  getByID,
  create,
  update,
  remove,
  migrate,
};

export default NotesService;
